@if (toggled | async) {
  @if (filter.searchable) {
    <div
      class="complex-filter-checkbox-tree__search"
      [ngClass]="'complex-filter-checkbox-tree__search--' + nestingDisplayMode"
    >
      <ftr-search-input
        name="searchTerms"
        [required]="false"
        [ngFormControl]="searchControl"
        autocomplete="off"
        label="Search"
        [clearType]="searchInputClear.Cross"
      ></ftr-search-input>
    </div>
  }
  <ftr-animated-remote
    [remote]="viewModel"
    [loadingTemplate]="loading"
    [failureTemplate]="failure"
    [emptyTemplate]="success"
    [successTemplate]="success"
  >
    <ng-template #loading>
      <ftr-complex-filter-loading></ftr-complex-filter-loading>
    </ng-template>
    <ng-template #failure>
      <ftr-complex-filter-error [refreshOptions]="refreshOptions"></ftr-complex-filter-error>
    </ng-template>
    <ng-template #success>
      <div class="complex-filter-checkbox-tree" [ngClass]="'complex-filter-checkbox-tree--' + nestingDisplayMode">
        <div class="complex-filter-checkbox-tree__form" [hidden]="totalFilterCount === 0">
          <ftr-checkbox-tree
            [items]="checkboxes"
            [enableSelectAll]="false"
            [enableSelectFiltered]="false"
            (childValueChange)="onValueChange($event)"
            (totalFilterCount)="totalFilterCount = $event"
            [maxSelectedItems]="filter.maxSelectedOptions"
          ></ftr-checkbox-tree>
        </div>
        @if (searchTerm && totalFilterCount === 0) {
          <ftr-complex-filter-empty [searchTerm]="searchTerm"></ftr-complex-filter-empty>
        }
      </div>
    </ng-template>
  </ftr-animated-remote>
}
